<bn-loading-overlay></bn-loading-overlay>

<!-- <ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Questionário FGEnergia</h5>
<div class="blur"> 
  <div class="container" *ngIf="valoresPesquisaForm; else carregando">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="bn-form-group row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
        [disabled]="!pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="bn-form-group row">
      <div class="col-md-3">
        <label class="form-label">Nome do Representante: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input disabled class="form-control" formControlName="cnpjCliente">
      </div>
     
        <div class="col-md-3">
          <label class="form-label">CNPJ do Representante: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
          </label>
          <input disabled class="form-control" formControlName="isEsco">
        </div>
        <div class="col-md-3">
          <label class="form-label">Relação do Representante: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
          </label>
          <input disabled class="form-control" formControlName="ideRascunho">
        </div>
     
        <div class="col-md-3">
          <label class="form-label">Telefone do Representante: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
          </label>
          <input disabled class="form-control" formControlName="token">
        </div>
        <div class="col-md-3">
          <label class="form-label">Telefone do Representante: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
          </label>
          <input disabled class="form-control" formControlName="dataAprovacao">
        </div>
    </div>

  </form>
</div>
</div> -->

<app-limite-historico-listagem 
  [historico]="historico"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  (aoMudarPagina)="mudancaPagina($event)"
  (apenasAlteracoesManuais)="changeCheck($event)">
</app-limite-historico-listagem>
